import { gql } from "@apollo/client";
import Fragments from "features/quote/fragments";

export const DOWNLOAD_PRODUCTS_QUERY = gql`
  query downloadProducts($quoteId: Int!, $products: [Int]!) {
    downloadProducts(quoteId: $quoteId, products: $products) {
      name
      content
    }
  }
`;

export const QUOTE_PRODUCT_QUERY = gql`
  query quoteProduct($quoteProductId: Int!) {
    quoteProduct(quoteProductId: $quoteProductId) {
      ...quoteProduct
      firstInstallmentDate
      cellParamsConfigurations {
        monthDate
        params {
          scheduleTypeCellParamId
          scheduleTypeCellParamCode
          value
        }
      }
      quoteProductServices {
        id
        duration
        financedYN
        periodicity
        quoteProductId
        serviceAmount
        servicePercent
        serviceTypeCode
        serviceTypeName
        serviceTypeId
        calcTypeId
      }
      priceCard {
        priceCardId
        priceCardName
        statusId
        priceCardVersion
        priceCardGuid
        leasingFactorTypeId
        leasingFactorTypeCode
        rvCalculationId
        rvCalculationCode
        allowRiskBasePricing
        matrixLines {
          id
          tenorFrom
          tenorTo
          purchasePriceFrom
          purchasePriceTo
          customerInterestPercent
          subsidyPercent
          residualValuePercent
          interestUseSlider
          enableDealerCommisionPreview
          enableDealerSubsidyPreview
          parameterForSharing
          residualValueVisible
          flatRate
        }
        ratingBasedPricings {
          id
          rating
          interest
        }
      }
    }
  }
  ${Fragments.quoteProduct}
`;

export const PRODUCT_SCHEDULE = gql`
  query quoteProduct($quoteProductId: Int!) {
    quoteProduct(quoteProductId: $quoteProductId) {
      quoteProductId
      productSchedule {
        columnDefinitions {
          columnCaption
          columnName
          displayFormat
          displayOrder
          isService
          scheduleTypeDetailId
          systemTypeName
        }
        scheduleLines {
          values {
            columnCaption
            columnName
            displayFormat
            isDisplayed
            systemTypeName
            value
          }
        }
      }
    }
  }
`;

export const INSURANCE_DETAILS = gql`
  query insuranceDetails($quoteId: Int!, $quoteProductId: Int!) {
    insuranceDetails(quoteId: $quoteId, quoteProductId: $quoteProductId) {
      quoteAssetId
      assetName
      brandName
      kindOfObjectName
      notFoundCategories
      insuranceTypes {
        insuranceTypeId
        insuranceTypeName
        insuranceClassId
        selectedConvention {
          conventionId
          insurerId
          conventionAlias
          assetInsuranceCategoryId
        }
        conventions {
          conventionId
          conventionAlias
          insurerId
          assetInsuranceCategoryId
        }
      }
    }
  }
`;

export const SCHEDULE_TYPE_CELL_PARAM_DEFINITIONS = gql`
  query scheduleTypeCellParamDefinitions($productId: Int!, $scheduleTypeId: Int!) {
    scheduleTypeCellParamDefinitions(productId: $productId, scheduleTypeId: $scheduleTypeId) {
      scheduleTypeCellParamId
      scheduleTypeId
      cellParamName
      cellParamDisplayName
      cellParamTypeId
      displayOrderNo
      cellParamTypeName
      color
    }
  }
`;

export const INTEREST_TYPE_DETAIL = gql`
  query interestTypeDetail(
    $quoteId: Int!
    $quoteProductId: Int!
    $duration: Int!
    $periodicity: Int!
    $residualValuePercent: Float!
  ) {
    interestTypeDetail(
      quoteId: $quoteId
      quoteProductId: $quoteProductId
      duration: $duration
      periodicity: $periodicity
      residualValuePercent: $residualValuePercent
    ) {
      quoteProductId
      floatingInterestPercent
      bankMargin
      bankMargin_PeriodMin
      bankMargin_PeriodMax
      variableInterestDate
    }
  }
`;

export const GET_PRODUCT_TYPES = gql`
  query productTypesByQuoteId($quoteId: Int!) {
    productTypesByQuoteId(quoteId: $quoteId) {
      id
      name
    }
  }
`;
